import React from "react";
import PolicyLayout from "../Policy/PolicyLayout";

const RefundReturnForm = () => {
  const sections = [
    {
      id: "non-refundable",
      title: "Digital Vouchers Are Non-Refundable",
      body: (
        <>
          <p>
            All purchased digital vouchers ("Digital Voucher/s") on
            GlobalGiftPass.io are final and cannot be canceled, returned, or
            refunded once they have been successfully purchased and delivered.
          </p>
          <p>To ensure a seamless transaction, please verify before checkout:</p>
          <ul>
            <li>Selection of the correct product</li>
            <li>The appropriate store or country for the voucher</li>
            <li>The correct currency and payment method</li>
          </ul>
        </>
      ),
    },
    {
      id: "eligibility",
      title: "Refund Eligibility",
      body: (
        <>
          <p>
            Refunds are <b>strictly limited</b> to cases where GlobalGiftPass.io
            is at fault. Refunds will only be processed under the following
            circumstances:
          </p>
          <ul>
            <li>
              A valid Digital Voucher was not delivered to the customer's
              registered account or email address due to an issue caused by
              GlobalGiftPass.io
            </li>
          </ul>
          <p>
            In such cases, refunds will be processed exclusively through the
            original mode of payment. Refund requests will not be entertained
            for incorrect selections made by the customer during the purchase
            process.
          </p>
        </>
      ),
    },
    {
      id: "delivery",
      title: "Delivery Timelines",
      body: [
        "Purchased Digital Vouchers are typically delivered to the customer's registered account or email address within 24 hours of successful payment. The confirmation email will be received immediately after payment.",
        <p key="if">
          If you do not receive your Digital Voucher within this timeframe, it
          is your responsibility to <b>submit a formal complaint</b> through
          the GlobalGiftPass.io website. Failure to submit a complaint within
          48 hours of payment will be deemed as acceptance that the Digital
          Voucher was successfully delivered.
        </p>,
        "Refunds will be done only through the original mode of payment and will be processed within 10 to 45 days depending on the issuing bank of the credit card.",
      ],
    },
    {
      id: "cancellation",
      title: "Cancellation Policy",
      body: "Customers can cancel their order or requested service within 24 hours; refunds will be made back to the payment solution used initially. Please allow up to 45 days for the refund transfer to be completed.",
    },
    {
      id: "complaints",
      title: "Complaints and Resolution",
      body: (
        <>
          <p>
            Complaints regarding non-delivery or other issues related to your
            purchased Digital Voucher must include:
          </p>
          <ul>
            <li>Proof of payment</li>
            <li>The order reference number</li>
            <li>A clear description of the issue encountered</li>
          </ul>
          <p>
            Our team will review the complaint and respond promptly to resolve
            the matter. If a refund is deemed appropriate, it will be processed
            in accordance with this policy.
          </p>
        </>
      ),
    },
    {
      id: "exceptions",
      title: "Exceptions to Refunds",
      body: (
        <>
          <p>Refunds or reissuance of Digital Vouchers are not applicable in the following cases:</p>
          <ul>
            <li>Incorrect purchase details (store selection, currency, or payment method)</li>
            <li>Expired or already-redeemed Digital Vouchers</li>
            <li>Customer failure to submit a complaint within the specified timeframe</li>
          </ul>
        </>
      ),
    },
    {
      id: "law",
      title: "Governing Law",
      body: "This policy is governed by the laws of the United Arab Emirates (UAE). Any disputes or claims arising from the purchase or use of Digital Vouchers shall be resolved under UAE jurisdiction.",
    },
    {
      id: "contact",
      title: "Contact Information",
      body: (
        <>
          <p>For questions or concerns about this policy, contact us at:</p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:support@globalgiftpass.io">support@globalgiftpass.io</a>
            </li>
            <li>VentureWorks Dynamics LLC, Sharjah Media City, Sharjah, UAE</li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <PolicyLayout
      slug="rr"
      eyebrow="REFUND & RETURN POLICY"
      title="Our refund"
      accent="commitment"
      sub="Read this carefully before making any purchase — it explains exactly when refunds apply and how they're processed."
      lastUpdated="January 2026"
      intro={
        <p>
          At <b>GlobalGiftPass.io</b>, we strive to deliver an excellent user
          experience and maintain transparency in our operations. Please review
          our Refund &amp; Return Policy before making any purchase, as it
          outlines important details on eligibility for refunds or returns.
        </p>
      }
      notice="Digital vouchers are final once delivered. Submit any non-delivery complaint within 48 hours of payment."
      sections={sections}
    />
  );
};

export default RefundReturnForm;
